/**
 * This component is a tabbed view that allows the reseller to look at customer project charges and statements.
 */
import React, { Component } from 'react';
import withStyles from '@mui/styles/withStyles';
import { Paper, Typography } from '@mui/material';

import CustomerProjectStatement from '../customer/CustomerProjectStatement';

const styleSheet = theme => ({
    root: {
      flexGrow: 1,
      //marginTop: 10,
    },
    paper: {
      [theme.breakpoints.up('xs')]: {
        padding: theme.spacing(1),
      },
      [theme.breakpoints.up('sm')]: {
        padding: theme.spacing(2),
      },
      [theme.breakpoints.up('md')]: {
        padding: theme.spacing(3),
      },
      textAlign: 'left',
      color: theme.palette.text.secondary,
       marginTop: 16,
    },
    flex: {
      flex: 1,
    },
  });

class CustomerProjectStatementWrapper extends Component {
  render() {
     const classes = this.props.classes;

    return (
      <div className={classes.root}>
        <Paper className={classes.paper}>
          <Typography variant="h6" style={{marginBottom: '16px'}}>Project statements</Typography>
          <CustomerProjectStatement 
            cAccountId={this.props.customerAccountId} 
            projects={this.props.projects}
            auth={this.props.auth} 
            fbClientId={this.props.fbClientId}
            fbLogo={this.props.fbLogo}
            history={this.props.history} 
            initialStatement={0}
          />
        </Paper>
      </div>
    );

  }
}

export default withStyles(styleSheet)(CustomerProjectStatementWrapper);
